import React, { useState } from "react";
import { CONTAINER_SIZE } from "../../../utils/constants/homeConstants";
import styles from "./sizeContainer.module.css";

const SizeContainer = ({ containersize, children,graphComponents,isFullWidth,...rest }) => {
  const [isHovered, setIsHovered] = useState(false);
  const containerClassMap = {
      [CONTAINER_SIZE.EXTRA_SMALL]: styles.extraSmallcontainer,
      [CONTAINER_SIZE.SMALL]: styles.smallcontainer,
      [CONTAINER_SIZE.MEDIUM]: styles.mediumcontainer,
      [CONTAINER_SIZE.LARGE]: styles.largecontainer,
      [CONTAINER_SIZE.EXTRA_LARGE]: styles.extralargecontainer,
  };
  const containerClass = containerClassMap[containersize] || styles.defaultcontainer;
  const isHoverable = containersize === CONTAINER_SIZE.SMALL
    return (
      // <div className={`${isFullWidth ? styles.fullWidth : containersize===CONTAINER_SIZE.SMALL?styles.flexItem:containersize===CONTAINER_SIZE.MEDIUM?styles.mediumcont:styles.flexdata} ${graphComponents?.length>2&&styles.marginbottom}`}{...rest}>
      <div className={`${isFullWidth ? styles.fullWidth : (containersize===CONTAINER_SIZE.SMALL||containersize===CONTAINER_SIZE.EXTRA_SMALL)?styles.flexItem:styles.flexdata} ${graphComponents?.length>2&&styles.marginbottom}`}onMouseEnter={() => setIsHovered(true)}onMouseLeave={() => setIsHovered(false)}{...rest}>
        <div className={`${containerClass} ${isHoverable ? styles.hoverable : ""}`}>
          {/* {children} */}
          {React.Children.map(children, child =>
          React.isValidElement(child) ? React.cloneElement(child, { isHovered }) : child
          )}
        </div>
      </div>
    );
  };

export default SizeContainer;
